module.exports = __webpack_public_path__ + "static/media/bee-author.8b64bf74.png";